import uuid from 'uuid';

import { EditorState } from '@atlaskit/editor-prosemirror/state';
import { token } from '@atlaskit/tokens';

export const hubElementPlaceholderExtensionType =
	'com.atlassian.confluence.hub-element-placeholder';
export const hubElementPlaceholderExtensionKey = 'hub-element-placeholder';

// TODO: Replace templates here with something like getSectionExtensionContents from custom-sites-extensions/src/section/sectionConstants.tsx
// Section content structure
const sectionContentADF = {
	type: 'extensionFrame',
	attrs: {
		localId: null,
	},
	content: [
		{
			type: 'heading',
			attrs: {
				level: 1,
				localId: null,
			},
			content: [
				{
					type: 'text',
					text: 'header',
				},
			],
		},
		{
			type: 'paragraph',
			attrs: {
				localId: null,
			},
			content: [
				{
					type: 'text',
					text: 'subheader',
				},
			],
		},
		{
			type: 'paragraph',
			attrs: {
				localId: null,
			},
		},
		{
			type: 'extension',
			attrs: {
				extensionKey: hubElementPlaceholderExtensionKey,
				extensionType: hubElementPlaceholderExtensionType,
				parameters: { extensionTitle: 'Placeholder title' },
				text: null,
				layout: 'default',
				localId: null,
			},
		},
	],
};

const sectionContentNode = (state: EditorState) => state.schema.nodeFromJSON(sectionContentADF);

export const newSectionNode = (state: EditorState) =>
	state.schema.nodes.multiBodiedExtension.create(
		{
			extensionType: 'com.atlassian.confluence.hub-section',
			extensionKey: 'hub-section',
			layout: 'full-width',
			localId: uuid(),
			parameters: {
				extensionTitle: 'Section',
				backgroundColor: token('elevation.surface'),
				contentWidth: 'wide',
			},
		},
		sectionContentNode(state),
	);
